import React, {memo} from "react";
import { Button } from '@mui/material';


const ButtonImgMain = (props) =>{
    return(
            <Button variant={props.variant} type={props.type} onClick={props.onClick} className={props.class} disabled={props.disabled}>
                {
                    props.posision === 'right' ? 
                    (<>{props.name}<img src={props.img} alt="button icon" className="ml-2 w-[1.5rem]" /></>):
                    (<><img src={props.img} alt="button icon" className="mr-2 w-[1.5rem]" />{props.name}</>)
                }
            </Button>
    );
}

export default memo(ButtonImgMain);